import { Component, input } from '@angular/core';

@Component({
  selector: 'aura-simple-chip',
  templateUrl: './simple-chip.component.html',
  imports: [],
})
export class SimpleChipComponent {
  text = input.required<string>();
}
